import { classNames } from "@circle-react/helpers/twMergeWithCN";
import type { JSONContent } from "@tiptap/core";

import {
  anchorClassNames,
  legacyClassNames,
} from "@/react/helpers/cssAnchorHelpers";

import { renderNode } from "./renderNode";
import { StaticEditedLabel } from "./StaticEditedLabel";
import type { SgidObjectMap } from "./types";

interface StaticMessageBodyProps {
  body: JSONContent;
  editedAt?: string | null;
  sgidToObjectMap?: SgidObjectMap;
}

// Renders a read-only chat message body directly from its ProseMirror JSON,
// with no editor instance. Reuses the same `tiptap-editor readonly` classes as
// the editor path so styling stays identical. Guard with `canRenderStatically`
// before using this.
export const StaticMessageBody = ({
  body,
  editedAt,
  sgidToObjectMap = {},
}: StaticMessageBodyProps) => {
  const content = body.content ?? [];
  const lastIndex = content.length - 1;
  const isLastNodeParagraph = content[lastIndex]?.type === "paragraph";
  const editedLabel = editedAt ? (
    <StaticEditedLabel editedAt={editedAt} />
  ) : null;

  return (
    <div
      className={classNames(
        anchorClassNames("tiptap-editor"),
        legacyClassNames("readonly"),
        "whitespace-pre-wrap [overflow-wrap:anywhere]",
      )}
    >
      {content.map((node, index) =>
        renderNode(
          node,
          index,
          sgidToObjectMap,
          index === lastIndex && isLastNodeParagraph ? editedLabel : undefined,
        ),
      )}
      {editedLabel && !isLastNodeParagraph ? editedLabel : null}
    </div>
  );
};
